import Poster from '@common/Poster'
import SelectGroupMemberSelect from '@components/LocalMerchant/SiDa/Common/SelectGroupMember'
import { RouterView } from '@merchant-backend/common-components'
import {
  getCaseManageTitle,
  getCaseName,
  getMerchantInfo,
  isSiDaTeam
} from '@util'
import {
  isWeddingDressProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { Button, Flex, Input, Modal } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import store from '../store'
import Api from './api'
import DelCaseModal from './DelCaseModal'
import List from './List'
const { Search } = Input

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    store.updateMerchantInfo(getMerchantInfo()) //获取当前用户信息
    this.state = {
      delCaseVisible: false
    }
  }

  componentDidMount() {
    // 检测是否需要竖图弹窗接口，需要取返
    store.getMealVerticalImg()
    store.getDraftCount()
    setTimeout(function() {
      document
        .getElementById('contentMainDiv')
        .addEventListener('scroll', store.loadMore)
    }, 300)
    this.setAsyncRouteLeaveHook(this.routerWillLeave)
  }

  componentWillUnmount() {
    store.reset()
    document
      .getElementById('contentMainDiv')
      .removeEventListener('scroll', store.loadMore)
  }

  setAsyncRouteLeaveHook = hook => {
    const { router, route } = this.props
    router.setRouteLeaveHook(route, nextLocation => {
      const { orderIsChanged } = store
      if (orderIsChanged) {
        hook(nextLocation)
      }
      return !orderIsChanged
    })
  }

  routerWillLeave = nextLocation => {
    Modal.confirm({
      title: '是否保存此次案例排序?',
      onOk: async () => {
        await store.saveCaseSort()
        hashHistory.push(nextLocation.pathname)
      },
      onCancel: async () => {
        await store.sortCancle()
        hashHistory.push(nextLocation.pathname)
      }
    })
  }

  _queryConsultCountList = async () => {
    const { success, data } = await Api.getConsultCount()
    if (success) {
      return data
    }
  }

  render() {
    const { isSort } = store
    const { delCaseVisible } = this.state
    const Extra = isSort ? null : (
      <>
        <Search
          placeholder="输入案例名，按回车键搜索"
          onSearch={store.onTitleSearch}
          style={{ width: 250, marginRight: 16 }}
          value={store.title_search}
          onChange={e => store.onTitleChange(e.target.value)}
        />
        <span
          style={{
            cursor: 'pointer',
            color: '#333',
            marginRight: 10,
            fontSize: 14
          }}
          onClick={() => hashHistory.push('/localMerchant/case/draftList')}
        >
          草稿箱({store.draftCount})
        </span>
        {isWeddingDressProperty() || isWeddingRingJewelryProperty() ? null : (
          <Button
            type="primary"
            onClick={async () => {
              const isConsult = await this._queryConsultCountList()
              if (isConsult == 1) {
                this.setState({
                  delCaseVisible: true
                })
                return
              }
              store.publishFn()
            }}
          >
            发布{getCaseName()}
          </Button>
        )}
      </>
    )
    return (
      <>
        <Poster
          style={{
            margin: '20px 20px -20px 20px'
          }}
          id="2062"
          propertyName="WEB_CASE_LIST_TOP_NOTIFY"
        />
        <RouterView
          title={getCaseManageTitle()}
          extra={
            isSiDaTeam() ? (
              <Flex vc>
                <SelectGroupMemberSelect
                  style={{ width: 140, marginRight: 24 }}
                  onChange={value => store.selectGroupMember(value)}
                  needSelf
                />
                {Extra}
              </Flex>
            ) : (
              Extra
            )
          }
          bodyStyle={{ padding: '0 24px 60px 24px' }}
        >
          <List tab={this.props?.location?.query?.tab} />
          <DelCaseModal
            visible={delCaseVisible}
            onCancel={() => {
              this.setState({
                delCaseVisible: false
              })
              store.$getList()
            }}
          />
        </RouterView>
      </>
    )
  }
}
